import React from 'react';
import { Button } from 'reactstrap';

const FileUploader = React.forwardRef(({ handleChange, children, accept, isDropZone, dragText, enableDrop = true, dragActive: controlledDragActive, ...buttonProps }, ref) => {
    const hiddenFileInput = React.useRef(null);
    const [internalDragActive, setInternalDragActive] = React.useState(false);
    const dragActive = controlledDragActive ?? internalDragActive;

    React.useImperativeHandle(ref, () => ({
        trigger: () => {
            if (hiddenFileInput.current) {
                hiddenFileInput.current.click();
            }
        }
    }));

    const triggerFilePicker = () => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };

    const handleClick = () => {
        triggerFilePicker();
    };

    const handleChangeUpload = event => {
        const fileUploaded = event.target.files && event.target.files[0];
        if (!fileUploaded) {
            return;
        }

        handleChange(fileUploaded);
        event.target.value = '';
    };

    const handleDragEvent = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDragOver = event => {
        handleDragEvent(event);
        if (isDropZone && enableDrop) {
            setInternalDragActive(true);
        }
    };

    const handleDragLeave = event => {
        handleDragEvent(event);
        if (isDropZone && enableDrop) {
            setInternalDragActive(false);
        }
    };

    const handleDrop = event => {
        handleDragEvent(event);
        if (!enableDrop) {
            return;
        }
        if (isDropZone) {
            setInternalDragActive(false);
        }

        const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (!file) {
            return;
        }

        handleChange(file);
    };

    const resolvedClassName = [
        buttonProps.className,
        isDropZone && dragActive ? 'upload-button--drag-active' : null,
        isDropZone && dragActive ? 'doc-card__drop-zone--active' : null
    ].filter(Boolean).join(' ');

    const displayedChildren = isDropZone && dragActive && dragText ? dragText : children;

    return (
        <React.Fragment>
            <Button
                {...buttonProps}
                className={resolvedClassName || undefined}
                onClick={handleClick}
                onDragEnter={enableDrop ? handleDragOver : undefined}
                onDragOver={enableDrop ? handleDragOver : undefined}
                onDragLeave={enableDrop ? handleDragLeave : undefined}
                onDrop={enableDrop ? handleDrop : undefined}
                data-dropzone={isDropZone ? 'true' : 'false'}
            >
                {displayedChildren}
            </Button>
            <input
                type="file"
                ref={hiddenFileInput}
                accept={accept}
                onChange={handleChangeUpload}
                style={{ display: 'none' }}
            />
        </React.Fragment>
    );
});

FileUploader.displayName = 'FileUploader';
export default FileUploader;